import { ScheduleException } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/exception.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { Trans, useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps, useAlert } from '@frontend/design-system';
import { AvailabilitySettingsTrackingIds } from '../../../../trackingIds/availability-settings-tracking';

type Props = {
  locationId: string;
  selectedException: ScheduleException | null;
  modalProps: ModalControlModalProps;
  onClose: () => void;
};

export const DeleteConfirmationModal = ({ locationId, selectedException, modalProps, onClose }: Props) => {
  const { t } = useTranslation('schedule-settings');
  const alert = useAlert();

  const deleteRuleExceptionMutation = SchedulerV3.Mutations.useDeleteScheduleExceptionMutation({
    options: {
      onError: () => {
        alert.error(t('Failed to delete rule exception'));
      },
      onSuccess: () => {
        alert.success(t('Rule exception deleted successfully'));
        onClose();
      },
    },
  });

  const onDelete = () => {
    const ruleId = selectedException?.id || '';
    if (!ruleId) return;

    SchedulerV3.trackPendoEvent(AvailabilitySettingsTrackingIds.events.ruleDeleteClicked, {
      ruleType: 'exception',
      ruleId,
      locationId,
    });

    deleteRuleExceptionMutation.mutate({
      id: ruleId,
      locationId,
    });
  };

  return (
    <ConfirmationModal
      {...modalProps}
      destructive
      title={t('Delete Rule Exception')}
      message={
        <Trans
          t={t}
          i18nKey='Are you sure you want to delete this rule exception <strong>{{name}}</strong>?'
          values={{ name: selectedException?.name }}
          components={{ strong: <strong /> }}
        />
      }
      confirmLabel={t('Delete')}
      onConfirm={onDelete}
    />
  );
};
